/** @format */
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import { RecommendationsVariant } from '@toucan/common/services/feature-flags/constants';

import { MarketContext } from '@toucan/client/global/market';

import { ModelRecommendationsFlag } from '@toucan/client/core/recommendations';

import { useSimilarModelRecommendations } from '@toucan/client/features/search/components/model-search-results/hooks/use-similar-model-recommendations';
import { SearchResultsType } from '@toucan/client/features/search/components/model-search-results/types';

import { ModelRecommendationsCarousel } from './components/model-recommendations-carousel';
import { ModelRecommendationsCarouselSkeleton } from './components/model-recommendations-carousel/skeleton';

export const OutOfStockRecommendations = ({
    searchResults,
    outOfStockRecommendationsFlag,
    noInStockResults,
}: {
    searchResults: SearchResultsType;
    outOfStockRecommendationsFlag?: ModelRecommendationsFlag;
    noInStockResults: boolean;
}) => {
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    const shouldRequestOutOfStockRecommendations = Boolean(
        outOfStockRecommendationsFlag?.isEnabled && noInStockResults
    );

    function getModelsIdsFromSearchResults() {
        return searchResults.results
            .map(({ modelId }) => Number(modelId.values[0]))
            .filter((modelId) => !isNaN(modelId));
    }

    const outOfStockRecommendations = useSimilarModelRecommendations(
        getModelsIdsFromSearchResults(),
        activeMarket.code,
        {
            enabled: shouldRequestOutOfStockRecommendations,
        }
    );

    if (!outOfStockRecommendationsFlag) {
        return null;
    }

    if (
        outOfStockRecommendationsFlag.variant?.name ===
            RecommendationsVariant.VARIANT &&
        outOfStockRecommendations.isFetching
    ) {
        return <ModelRecommendationsCarouselSkeleton />;
    }

    if (outOfStockRecommendations.data) {
        return (
            <ModelRecommendationsCarousel
                title={t('Similar products')}
                pageModelIds={getModelsIdsFromSearchResults()}
                modelRecommendations={{
                    ...outOfStockRecommendations.data,
                    ...outOfStockRecommendationsFlag,
                }}
            />
        );
    }

    return null;
};
